"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BsButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.BsButton = styled_components_1.default.button(({ theme: { transition } }) => ({
    transition: transition.fast,
    color: 'white',
}), ({ theme, variant }) => theme.buttons[variant || 'primary']);
//# sourceMappingURL=bs-button.js.map